import PubSub from "underpub-js";
import Equalizer from "../../../../scripts/classes/Equalizer";
import Slick from "slick-carousel";
import gsap from 'gsap';

var CommunityEngagementQuoteSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-CommunityEngagementQuoteSlider',
	};

	$.extend(true, this.options, options);

};

CommunityEngagementQuoteSlider.prototype.init = function() {

	var self = this;

	// sliders
	this.$quoteSlider = this.options.$el.find(`.${self.options.baseClass}__quoteSlider`);

	this.$quoteSlides = this.options.$el.find(`.${self.options.baseClass}__quoteSlide`);
	this.$quoteSlideQuoteSymbols = this.options.$el.find(`.${self.options.baseClass}__quoteSlide .${self.options.baseClass}__quoteSymbol`);
	this.$quoteSlideQuotes = this.options.$el.find(`.${self.options.baseClass}__quoteSlide .${self.options.baseClass}__quote`);
	this.$quoteSlideBylines = this.options.$el.find(`.${self.options.baseClass}__quoteSlide .${self.options.baseClass}__byline`);

	// initialize card slider
	this.$quoteSlider.slick({
		arrows: false,
		fade: true,
		speed: 400,
		slidesToShow: 1,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 8000,
	});

	// equalize slide heights
	this.slideEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__slideContentWrapper`) );

	this.slideEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.slideEq.equalizeHeights();
	});


	// arrow buttons
	this.options.$el.find(`.${self.options.baseClass}__previousButton`).on('click', function() {

		self.$quoteSlider.slick('slickPrev');

	});

	this.options.$el.find(`.${self.options.baseClass}__nextButton`).on('click', function() {

		self.$quoteSlider.slick('slickNext');

	});

	this.$quoteSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	
		var activeSlideNumber = nextSlide + 1;

		self.options.$el.find(`.${self.options.baseClass}__navDot`).removeClass(`${self.options.baseClass}__navDot--active`);

		self.options.$el.find(`.${self.options.baseClass}__navDot` + '[data-slide-number="' + activeSlideNumber + '"]').addClass(`${self.options.baseClass}__navDot--active`);

	});

	this.$quoteSlider.on('afterChange', function(event, slick, currentSlide) {

		var $currentSlide = $(slick.$slides.get(currentSlide));

		self.animateSlideIn($currentSlide);

	});

	// fade in first slide
	this.animateSlideIn(this.$quoteSlides.eq(0));

};

CommunityEngagementQuoteSlider.prototype.animateSlideIn = function($currentSlide) {

	var self = this;


	var $slideQuoteSymbol = $currentSlide.find(`.${self.options.baseClass}__quoteSymbol`);
	var $slideQuote = $currentSlide.find(`.${self.options.baseClass}__quote`);
	var $slideByline = $currentSlide.find(`.${self.options.baseClass}__byline`);

	gsap.set(self.$quoteSlideQuoteSymbols, {
		opacity: 0,
		y: 10
	});
	gsap.set(self.$quoteSlideBylines, {
		opacity: 0,
		y: 10
	});
	gsap.set(self.$quoteSlideQuotes, {
		opacity: 0,
		y: 10
	});

	gsap.timeline(
		{
			defaults: {
				duration: 0.5,
				ease: "power1.out"
			}
		}
	)
	.to($slideQuoteSymbol, {
		opacity: 1,
		y: 0
	})
	.to($slideQuote, {
		opacity: 1,
		y: 0
	}, ">-0.25")
	.to($slideByline, {
		opacity: 1,
		y: 0
	}, ">-0.25")
	;

};

export default CommunityEngagementQuoteSlider;
